(() => {
  const root = document.querySelector('[data-caddie-root]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const config = JSON.parse(root.querySelector('[data-caddie-config]').textContent);
  const t = config.messages;
  const dialog = root.querySelector('dialog');
  const messages = root.querySelector('[data-caddie-messages]');
  const results = root.querySelector('[data-caddie-results]');
  const refine = root.querySelector('[data-caddie-refine]');
  const composer = root.querySelector('[data-caddie-composer]');
  const input = composer.querySelector('input');
  const contact = root.querySelector('#CaddieContact');
  const storageKey = 'albi.caddie.v1';
  let products = [], stockists = [], loadPromise, view = 'conversation', busy = false, intent = 'range';
  let aiEnabled = /^https:\/\//.test(config.endpoint || '');
  let state = {shortlist: [], messages: [], profile: {audience: '', occasion: ''}};
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    if (saved && Array.isArray(saved.shortlist) && Array.isArray(saved.messages)) {
      state.shortlist = saved.shortlist.slice(0, 12).filter(x => typeof x.handle === 'string').map(x => ({handle: x.handle.slice(0, 100), colour: String(x.colour || '').slice(0, 100), size: String(x.size || '').slice(0, 30)}));
      state.messages = saved.messages.slice(-16).filter(x => ['user', 'assistant'].includes(x.role) && typeof x.content === 'string').map(x => ({role: x.role, content: x.content.slice(0, 1800)}));
      state.profile = {audience: ['men','women','unisex',''].includes(saved.profile?.audience) ? saved.profile.audience : '', occasion: String(saved.profile?.occasion || '').slice(0, 100)};
    }
  } catch (_) {}
  function node(tag, className, text) {
    const n = document.createElement(tag);
    if (className) n.className = className;
    if (text !== undefined) n.textContent = text;
    return n;
  }
  function save() {
    try {sessionStorage.setItem(storageKey, JSON.stringify(state));} catch (_) {}
    root.querySelector('[data-caddie-count]').textContent = state.shortlist.length;
    updateEnquiry();
  }
  function status() {
    root.querySelector('[data-caddie-status]').textContent = aiEnabled ? t.ai_status : t.guided_status;
    root.querySelector('[data-caddie-preview]').hidden = aiEnabled;
    input.placeholder = aiEnabled ? t.chat_placeholder : t.search_placeholder;
  }
  function showMessage(content, role = 'assistant', persist = true) {
    const n = node('div', 'caddie-message');
    n.dataset.role = role;
    n.append(node('span', 'caddie-message-label', role === 'user' ? t.you : 'Caddie'), node('span', '', content));
    messages.append(n);
    if (persist) {state.messages.push({role, content});state.messages = state.messages.slice(-16);save();}
    n.scrollIntoView({block:'nearest', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }
  function setView(name) {
    view = name;
    root.querySelectorAll('[data-caddie-view]').forEach(n => {n.hidden = n.dataset.caddieView !== name;});
    root.querySelectorAll('[data-caddie-tab]').forEach(n => {n.setAttribute('aria-pressed', String(n.dataset.caddieTab === name));});
    composer.hidden = name !== 'conversation';
    if (name === 'shortlist') renderShortlist();
    if (name === 'enquiry') updateEnquiry();
    root.querySelector('[data-caddie-scroll]').scrollTop = 0;
  }
  function safeImage(url) {
    try {const u = new URL(url);return u.protocol === 'https:' && u.hostname === 'cdn.shopify.com' ? u.href : '';} catch (_) {return '';}
  }
  async function loadCatalogue() {
    if (!loadPromise) loadPromise = fetch(config.catalogueUrl, {credentials:'same-origin'}).then(r => {if (!r.ok) throw new Error('catalogue');return r.json();}).then(data => {
      products = (data.products || []).filter(p => typeof p.handle === 'string' && /^[a-z0-9-]+$/.test(p.handle) && typeof p.title === 'string');
      stockists = Array.isArray(data.stockists) ? data.stockists : [];
      state.shortlist = state.shortlist.filter(x => products.some(p => p.handle === x.handle));
      save();
      return products;
    }).catch(() => {loadPromise = undefined;showMessage(t.catalogue_error);return [];});
    return loadPromise;
  }
  async function open(handle) {
    if (!dialog.open) dialog.showModal();
    const available = await loadCatalogue();
    if (handle && available.some(p => p.handle === handle)) {
      setView('conversation');
      const p = available.find(x => x.handle === handle);
      showMessage(t.piece_intro.replace('{product}', p.title));
      renderProducts([p]);
      choices([{label:t.ask_piece, action:()=>send(t.ask_piece_text.replace('{product}', p.title))}, {label:t.arrange_purchase, action:()=>{add(p.handle);setView('enquiry');}}]);
    }
  }
  function choices(items) {
    refine.replaceChildren();
    refine.hidden = !items.length;
    for (const item of items) {const b = node('button','',item.label);b.type = 'button';b.addEventListener('click',item.action);refine.append(b);}
  }
  function productUrl(p) {return '/products/' + encodeURIComponent(p.handle);}
  function renderProducts(list) {
    results.replaceChildren();
    for (const p of list.slice(0, 6)) {
      const card = node('article','caddie-product');
      const imageUrl = safeImage(p.image);
      if (imageUrl) {const img = node('img');img.src = imageUrl;img.alt = p.imageAlt || p.title;img.loading = 'lazy';img.width = 208;img.height = 300;card.append(img);}
      const detail = node('div','caddie-product-detail');
      detail.append(node('h4','',p.title),node('p','',(p.description || '').replace(/Part of the Albi Spring\/Summer 2026 collection\./,'').trim()));
      if (p.colours?.length) detail.append(node('p','',p.colours.join(' / ')));
      const link = node('a','',t.view_piece);link.href = productUrl(p);detail.append(link);
      const b = node('button','',state.shortlist.some(x=>x.handle===p.handle) ? t.saved : t.save_piece);b.type='button';b.dataset.handle = p.handle;b.dataset.added = String(state.shortlist.some(x=>x.handle===p.handle));
      b.addEventListener('click',()=>{add(p.handle);b.textContent=t.saved;b.dataset.added='true';});
      detail.append(b);card.append(detail);results.append(card);
    }
  }
  function add(handle) {
    if (state.shortlist.some(x => x.handle === handle)) return;
    if (state.shortlist.length >= 12) {showMessage(t.shortlist_limit);return;}
    if (!products.some(p => p.handle === handle)) return;
    state.shortlist.push({handle, colour:'', size:''});save();
  }
  function selectField(label, values, value, onChange, id) {
    const field = node('div');const l = node('label','',label);l.htmlFor = id;
    const s = node('select');s.id = id;const choose = node('option','',t.help_choose);choose.value = '';s.append(choose);
    for (const v of values || []) {const opt = node('option','',v);opt.value = v;s.append(opt);}s.value = value;
    s.addEventListener('change',()=>onChange(s.value));field.append(l,s);return field;
  }
  function renderShortlist() {
    const container = root.querySelector('[data-caddie-shortlist]');container.replaceChildren();
    if (!state.shortlist.length) container.append(node('p','caddie-empty',t.empty_shortlist));
    state.shortlist.forEach((item,index)=>{
      const p = products.find(x=>x.handle===item.handle);if (!p) return;
      const row=node('div','caddie-shortlist-item'), top=node('div','caddie-shortlist-top');
      const url=safeImage(p.image);if(url){const img=node('img');img.src=url;img.alt=p.title;img.width=62;img.height=78;top.append(img);}
      top.append(node('h4','',p.title));
      const remove=node('button','',t.remove);remove.type='button';remove.setAttribute('aria-label', t.remove+' '+p.title);remove.addEventListener('click',()=>{state.shortlist=state.shortlist.filter(x=>x.handle!==item.handle);save();renderShortlist();root.querySelectorAll('[data-handle]').forEach(b=>{if(b.dataset.handle===item.handle){b.dataset.added='false';b.textContent=t.save_piece;}});});top.append(remove);
      const fields=node('div','caddie-variant-fields');
      fields.append(selectField(t.colour,p.colours,item.colour,v=>{item.colour=v;save();},'caddie-colour-'+index),selectField(t.size,p.sizes,item.size,v=>{item.size=v;save();},'caddie-size-'+index));
      row.append(top,fields);container.append(row);
    });
  }
  function shortlistText() {
    return state.shortlist.map((item,index)=>{const p=products.find(x=>x.handle===item.handle);if(!p)return '';return `${index+1}. ${p.title}\n${t.colour}: ${item.colour || t.help_choose} | ${t.size}: ${item.size || t.help_choose}\n${p.url}`;}).filter(Boolean).join('\n\n');
  }
  function enquiryBody() {
    const conversation=state.messages.map(m=>`${m.role==='user'?t.you:'Caddie'}: ${m.content}`).join('\n\n').slice(-11000);
    return [`Caddie personal shopping enquiry`, `${t.shortlist}:\n${shortlistText() || t.no_pieces}`, `${t.shopping_preferences}: ${state.profile.audience || t.not_specified}; ${state.profile.occasion || t.not_specified}`, `Conversation (${aiEnabled?'AI-assisted':'guided collection preview'}):\n${conversation || t.no_conversation}`, `${t.enquiry_note}`].join('\n\n').slice(0,15000);
  }
  function updateEnquiry() {
    root.querySelector('[data-caddie-summary]').textContent=shortlistText() || t.no_pieces;
    root.querySelector('[data-caddie-body]').value=enquiryBody();
    root.querySelector('[data-caddie-email]').href='mailto:'+config.email+'?subject='+encodeURIComponent('ALBI — Caddie personal shopping enquiry')+'&body='+encodeURIComponent(enquiryBody().slice(0,7000));
  }
  function audienceChoices() {
    choices([{label:t.men,action:()=>pickAudience('men')},{label:t.women,action:()=>pickAudience('women')},{label:t.either,action:()=>pickAudience('')}]);
  }
  function pickAudience(value) {
    state.profile.audience=value;save();
    showMessage(value==='men'?t.men:value==='women'?t.women:t.either,'user');
    if(aiEnabled){send(intent==='gift'?t.gift_prompt:t.look_prompt,false);return;}
    showMessage(t.occasion_question);
    choices([{label:t.on_course,action:()=>pickOccasion('course')},{label:t.everyday,action:()=>pickOccasion('everyday')},{label:t.layers,action:()=>pickOccasion('layers')}]);
  }
  function eligible() {return products.filter(p=>!state.profile.audience || p.audience===state.profile.audience || p.audience==='unisex');}
  function pickOccasion(value) {
    state.profile.occasion=value;save();
    showMessage(value==='course'?t.on_course:value==='layers'?t.layers:t.everyday,'user');
    const all=eligible();
    let list;
    if(value==='layers') list=all.filter(p=>/mid layer|knit|hood|jersey|sweater|cardi|jacket|vest|1\/4 zip/i.test(p.category+' '+p.title));
    else {const tops=all.filter(p=>/polo|top|tee|tank/i.test(p.category+' '+p.title));const bottoms=all.filter(p=>/short|pant|jogger|skirt/i.test(p.category+' '+p.title));list=[...tops.slice(0,2),...bottoms.slice(0,2)];}
    showMessage(t.curated_intro);renderProducts(list);
    choices([{label:t.polos,action:()=>category('polo')},{label:t.bottoms,action:()=>category('short|pant|jogger|skirt')},{label:t.layers,action:()=>category('mid layer|knit|hood|jersey|sweater|cardi|jacket|vest')},{label:t.review_shortlist,action:()=>setView('shortlist')}]);
  }
  function category(pattern) {const list=eligible().filter(p=>new RegExp(pattern,'i').test(p.category+' '+p.title));renderProducts(list);showMessage(t.pieces_intro);}
  function showStockists() {
    showMessage(t.stockist_intro);results.replaceChildren();choices([]);
    const list=node('div','caddie-stockists');
    stockists.forEach(s=>{try{const u=new URL(s.url);if(u.protocol!=='https:')return;const a=node('a','',s.name);a.href=u.href;a.target='_blank';a.rel='noopener noreferrer';a.append(node('span','',s.location));list.append(a);}catch(_){}});
    const partner=node('a','',t.all_stockists);partner.href=config.retailUrl;list.append(partner);results.append(list);
    choices([{label:t.talk_team,action:()=>setView('enquiry')}]);
  }
  async function selectIntent(value) {
    await loadCatalogue();intent=value;setView('conversation');results.replaceChildren();
    if(value==='stockist'){showStockists();return;}
    if(value==='range'){showMessage(t.range_question);audienceChoices();return;}
    showMessage(value==='gift'?t.gift_question:t.audience_question);audienceChoices();
  }
  function search(query) {
    const terms=query.toLowerCase().replace(/[^a-z0-9 /-]/g,' ').split(/\s+/).filter(w=>w.length>1&&!['the','and','for','with','have','some','please','want','looking','me','can','you','show'].includes(w));
    const aliases={cream:'caddie cream',black:'liquorice',burgundy:'fig',beige:'dune',blue:'powder',grey:'storm',gray:'storm',rust:'clay'};
    const scored=eligible().map(p=>{const text=[p.title,p.description,p.category,...p.colours].join(' ').toLowerCase();return {p,score:terms.reduce((n,w)=>n+(text.includes(w)?3:(aliases[w]&&text.includes(aliases[w])?2:0)),0)};}).filter(x=>x.score>0).sort((a,b)=>b.score-a.score);
    showMessage(scored.length?t.search_found:t.search_empty);renderProducts(scored.map(x=>x.p));
    choices([{label:t.review_shortlist,action:()=>setView('shortlist')},{label:t.talk_team,action:()=>setView('enquiry')}]);
  }
  async function send(text, append = true) {
    text=String(text||'').trim().slice(0,1000);if(!text||busy)return;
    await loadCatalogue();if(append)showMessage(text,'user');input.value='';
    if(!aiEnabled){search(text);return;}
    busy=true;composer.querySelector('button').disabled=true;input.disabled=true;root.querySelector('[data-caddie-status]').textContent=t.thinking;
    try {
      const history=state.messages.slice(-12);if(!append)history.push({role:'user',content:text});
      const response=await fetch(config.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({messages:history,profile:state.profile,shortlist:state.shortlist,productHandle:config.productHandle}),signal:AbortSignal.timeout(25000),credentials:'omit'});
      if(!response.ok)throw new Error('service');
      const data=await response.json();
      if(typeof data.reply!=='string'||!data.reply.trim())throw new Error('reply');
      showMessage(data.reply.slice(0,2000));
      const handles=Array.isArray(data.productHandles)?data.productHandles.slice(0,6):[];
      if(handles.length)renderProducts(handles.map(h=>products.find(p=>p.handle===h)).filter(Boolean));
      choices((Array.isArray(data.suggestedReplies)?data.suggestedReplies:[]).filter(x=>typeof x==='string').slice(0,3).map(s=>({label:s.slice(0,80),action:()=>send(s.slice(0,80))})).concat(data.handoff?[{label:t.talk_team,action:()=>setView('enquiry')}]:[]));
    } catch (_) {
      aiEnabled=false;showMessage(t.ai_unavailable);choices([{label:t.explore_range,action:()=>selectIntent('range')},{label:t.talk_team,action:()=>setView('enquiry')}]);
    } finally {busy=false;composer.querySelector('button').disabled=false;input.disabled=false;status();}
  }
  root.querySelector('[data-caddie-open]').addEventListener('click',()=>open(config.productHandle));
  root.querySelector('[data-caddie-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  root.querySelectorAll('[data-caddie-tab]').forEach(b=>b.addEventListener('click',()=>setView(b.dataset.caddieTab)));
  root.querySelectorAll('[data-caddie-intent]').forEach(b=>b.addEventListener('click',()=>selectIntent(b.dataset.caddieIntent)));
  root.querySelector('[data-caddie-enquiry]').addEventListener('click',()=>setView('enquiry'));
  composer.addEventListener('submit',e=>{e.preventDefault();send(input.value);});
  root.querySelector('[data-caddie-reset]').addEventListener('click',()=>{state.messages=[];state.profile={audience:'',occasion:''};messages.replaceChildren();results.replaceChildren();choices([]);save();setView('conversation');});
  contact.addEventListener('submit',e=>{
    if(contact.querySelector('#CaddieMethod').value==='Phone'&&!contact.querySelector('#CaddiePhone').value.trim()){e.preventDefault();const phone=contact.querySelector('#CaddiePhone');phone.setCustomValidity(t.phone_required);phone.reportValidity();phone.addEventListener('input',()=>phone.setCustomValidity(''),{once:true});return;}
    updateEnquiry();
  });
  contact.querySelector('#CaddieMethod').addEventListener('change',()=>contact.querySelector('#CaddiePhone').setCustomValidity(''));
  document.addEventListener('click',e=>{const trigger=e.target.closest('[data-caddie-trigger]');if(trigger){e.preventDefault();open(config.productHandle);return;}const b=e.target.closest('[data-caddie-product]');if(b){e.preventDefault();open(b.dataset.caddieProduct);}});
  window.AlbiCaddie={open:(options={})=>open(options.productHandle || config.productHandle)};
  status();save();state.messages.forEach(m=>showMessage(m.content,m.role,false));
  if(window.location.hash==='#CaddieContact'&&root.querySelector('[data-caddie-sent]')){state.shortlist=[];state.messages=[];save();open().then(()=>setView('enquiry'));}
  else if(window.location.hash==='#CaddieContact'&&root.querySelector('[data-caddie-form-errors]')){open().then(()=>setView('enquiry'));}
})();

